/**
 * クエリストリングから指定した key の value を返す
 * @param  { String } key
 * @return { String }
 */
export function getQuery(key) {
  const queries = window.location.search.slice(1)
  if (!queries) return null

  const query = queries.split('&').find(query => query.split('=')[0] === key)
  if (!query) return null

  return query.split('=')[1]
}
